import { ImageEntity } from './image';

export type Palette = Array<{
  fill: string;
  border: string;
}>;

export enum FileTypes {
  PDF = 'pdf',
  JPG = 'jpg',
}

export enum MediaTypes {
  IMG = 'img',
  PDF = 'pdf',
  INSTA_STORY = 'instagram-story',
  INSTA_POST = 'instagram-post',
  FB_POST = 'fb-post',
  PINTEREST = 'pinterest',
}

export interface Lookbook {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  title: string;
  subTitle: string;
  slug: string;
  hash?: string;
  quizId: string;
  answers: any[]; //TODO: fix types
  media?: Media[];
  createdAt: string;
  style: string;
  location: string;
  details: string;
  flowers: string;
  music: string;
  accessories: string;
  dress: string;
  season: string;
  type: string;
  colorName: string;
  colors: Palette;
  images: {
    'flowers:section': ImageEntity[];
    'style:section': ImageEntity[];
    'tablesetting:section': ImageEntity[];
    'size:section': ImageEntity[];
    'venue:section': ImageEntity[];
    'decor:section': ImageEntity[];
    'dress:section': ImageEntity[];
    'accessories:section': ImageEntity[];
    'bridesmaids:section': ImageEntity[];
    'groomsmen:section': ImageEntity[];
    'music:section': ImageEntity[];
  };
}

export interface Media {
  url: string;
  type: MediaTypes;
}
